<template>
    <div class="discount-setting">
        <div class="setting-head">
            <span>优惠设置</span>
            <img @click="onJumpToPrefer" src="../../../assets/image/arrow_icon@2x.png" />
        </div>
        <div class="setting-list">
            <div class="setting-item" v-for="(item,index) in discountLadderSettingList" :key="index">
                <span>{{(type==3|| type == 4) && setType == 2?'每':''}}满{{item.conditionValue}}{{typeOption[type-1].val1}}{{type==3|| type == 4?'减':''}}{{item.discountValue}}{{typeOption[type-1].val2}}</span>
                <img class="img" v-if="!hide" @click="onPreferDelete(index)" src="../../../assets/image/sub@2x.png" />
            </div>
            <div v-show="discountLadderSettingList.length==0" class="setting-none" @click="onJumpToPrefer">去设置</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            default: 1
        },
        setType: {
            default: 1
        },
        hide: {
            default: true,
            type: Boolean
        },
        discountLadderSettingList: {
            default: function() {
                return []
            },
            type: Array
        }
    },
    data() {
        return {
            typeOption: [
                { label: '按件打折', key1: '满', val1: '件', key2: '打', val2: '折' },
                { label: '按金额打折', key1: '满', val1: '元', key2: '打', val2: '折' },
                { label: '按金额满减', key1: '满', val1: '元', key2: '减', val2: '元' },
                { label: '按件满减', key1: '满', val1: '件', key2: '减', val2: '元' },
            ]
        }
    },
    created() {
        console.log(this.hide)
    },
    methods: {
        onJumpToPrefer() {
            this.$emit('route')
        },
        onPreferDelete(index) {
            this.$emit('delete', index)
        }
    }
}
</script>

<style lang="less" scoped>
.discount-setting {
    padding: 20px 20px 30px;
    border: 2px solid #ddd;
    margin: 0 30px;
    .setting-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        span {
            font-size: 24px;
            line-height: 33px;
        }
        
        img {
            width: 44px;
            height: 44px;
        }
    }
    .setting-list {
        display: flex;
        flex-wrap: wrap;
        padding: 0 25px;
    }
    .setting-item {
        // width: 180px;
        padding: 0 20px;
        height: 50px;
        border-radius: 10px;
        background-color: #FFE7E6;
        color: #ED3939;
        font-size: 24px;
        line-height: 50px;
        font-weight: 500;
        text-align: center;
        position: relative;
        margin-top: 20px;
        margin-right: 20px;

        .img {
            width: 40px;
            height: 40px;
            position: absolute;
            top: -20px;
            right: -20px;
        }
    }
    .setting-none {
        width: 140px;
        height: 50px;
        line-height: 50px;
        font-size: 24px;
        border: 1PX solid #999;
        border-radius: 10px;
        color: #999;
        text-align: center;
        margin: 0 auto;
    }
}
</style>